module.exports = __webpack_public_path__ + "static/img/bindRadar.921d0c06.svg";